import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '@/components/Breadcrumbs';

import { useDataset } from '../../hooks/useSwr';
import DatasetIcon from '../../icons/DatasetIcon';

export function PublicDatasetCrumb(props: Partial<BreadcrumbData>) {
  const { datasetShareToken } = useParams();
  const datasetFetch = useDataset(undefined, { datasetShareToken });
  const dataset = datasetFetch?.data;
  return (
    <Breadcrumb icon={<DatasetIcon />} name={dataset?.name ?? ''} {...props} />
  );
}
